import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { toggleGroupStack, deleteAllGroupMembers, groupStackExportMembers } from '../../actions'
import { removeGroupMonitoring } from '../../../../../../components/Dialog/components/GroupMonitoring/actions'

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            toggleGroupStack,
            deleteAllGroupMembers,
            removeGroupMonitoring,
            groupStackExportMembers,
        },
        dispatch
    )
}

const mapStateToProps = (state) => {
    const activeGroupId = state.getIn(['ui', 'groupStack', 'activeGroup'])
    const activeGroup = state
        .getIn(['ui', 'entityStack', 'groups', 'groups'])
        .find((group) => _.toString(group.get('id')) === activeGroupId)

    const monitored = activeGroup ? activeGroup.getIn(['flags', 'monitoring']) : false

    return {
        activeGroup,
        isMonitored: monitored,
        groupStackState: state.getIn(['ui', 'groupStack']),
        members: state.getIn(['ui', 'groupStack', 'groupData', 'members']),
        changingGroupSettings: state.getIn(['ui', 'groupMonitoring', 'loading']),
    }
}

export default (GroupStackHeaderComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            changingGroupSettings: PropTypes.bool.isRequired,
            deleteAllGroupMembers: PropTypes.func.isRequired,
            groupStackState: PropTypes.object.isRequired,
            isMonitored: PropTypes.bool.isRequired,
            members: IPropTypes.list.isRequired,
            removeGroupMonitoring: PropTypes.func.isRequired,
            toggleGroupStack: PropTypes.func.isRequired,
        }

        render() {
            return <GroupStackHeaderComponent {...this.props} />
        }
    }

    return HocConnect
}
